export default __webpack_public_path__ + "static/media/try-atomic-energy-select.7e76c787.png";